const USDT = 'USDT';

export function usdtBaseSymbol(instrument) {
  const technical = String(instrument ?? '').trim();
  if (!technical) return null;
  const upper = technical.toUpperCase();
  let base;
  if (upper.endsWith(`-${USDT}`)) {
    base = technical.slice(0, technical.length - USDT.length - 1);
  } else if (upper.endsWith(USDT)) {
    base = technical.slice(0, technical.length - USDT.length);
  } else {
    return null;
  }
  base = base.trim();
  return base ? base.toUpperCase() : null;
}

export function instrumentDisplayLabel(instrument) {
  const technical = String(instrument ?? '').trim();
  return usdtBaseSymbol(technical) || technical;
}

export function buildInstrumentOptions(instruments) {
  if (!Array.isArray(instruments)) return [];
  const seen = new Set();
  const options = [];
  for (const entry of instruments) {
    const value = String(entry ?? '').trim();
    if (!value) continue;
    const key = value.toUpperCase();
    if (seen.has(key)) continue;
    const label = usdtBaseSymbol(value);
    if (!label) continue;
    seen.add(key);
    options.push({ value, label });
  }
  return options.sort((left, right) => {
    const byLabel = left.label.localeCompare(right.label, 'en', { sensitivity: 'base' });
    if (byLabel !== 0) return byLabel;
    return left.value.localeCompare(right.value, 'en', { sensitivity: 'base' });
  });
}

export function resolveInstrumentSelection(current, options) {
  const values = options.map((option) => option.value);
  if (values.includes(current)) return current;
  if (values.includes('BTC-USDT')) return 'BTC-USDT';
  if (values.includes('BTCUSDT')) return 'BTCUSDT';
  return values[0] || '';
}
